import * as yup from 'yup';
import { IngredientsList } from '../../components';
import { schema as recipeIngredients } from './recipe_ingredients';

export const component = IngredientsList;

export const schema = yup.object({
  headline: yup.string().required(),
  subheadline: yup.string().required(),
  recipes: yup.array(recipeIngredients).min(1),
});
